import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';

// Templates and default view 
import AdminLayout from '@/template/AdminLayout.vue';
import UserLayout from '@/template/UserLayout.vue';

import AdminHomeView from '@/views/Admin/HomeView.vue';
import UserHomeView from '@/views/User/HomeView.vue';

// Routes
const adminRoutes = [
    {
        path: '/admin',
        component: AdminLayout,
        meta: {
            requiresAuth: true,
            role: ['admin', 'secretary']
        },
        children: [
            {
                path: '/admin/financeiro',
                name: 'Financeiro',
                component: AdminHomeView
            },
            {
                path: '',
                name: 'Dashboard - Agendas',
                component: () => import(/* webpackChunkName: "Ver agenda" */ '@/views/Admin/Agenda/AgendaView.vue')
            },
            // {
            //     path: '/admin/agendas/criar',
            //     name: 'Dashboard - Criar locação',
            //     component: () => import(/* webpackChunkName: "Criar agenda" */ '@/views/Admin/Agenda/AgendaCreateView.vue')
            // },
            // {
            //     path: '/admin/agendas/editar/:id',
            //     name: 'Dashboard - Editar locação',
            //     component: () => import(/* webpackChunkName: "Editar agenda" */ '@/views/Admin/Agenda/AgendaEditView.vue')
            // },
            {
                path: '/admin/gestao',
                name: 'Dashboard - Gestão',
                component: () => import(/* webpackChunkName: "Gestão" */ '@/views/Admin/Gestao/ManagementView.vue'),
                meta: { role: ['admin'] }
            },
            {
                path: '/admin/gestao/logs',
                name: 'Dashboard - Logs',
                component: () => import(/* webpackChunkName: "Logs" */ '@/views/Admin/Gestao/LogsView.vue'),
            },
            {
                path: '/admin/gestao/salas/criar',
                name: 'Dashboard - Criar sala',
                component: () => import(/* webpackChunkName: "Criar sala" */ '@/views/Admin/Gestao/RoomCreateView.vue'),
                meta: { role: ['admin'] }
            },
            {
                path: '/admin/gestao/salas/editar/:id',
                name: 'Dashboard - Editar sala',
                component: () => import(/* webpackChunkName: "Editar sala" */ '@/views/Admin/Gestao/RoomEditView.vue'),
                meta: { role: ['admin'] }
            },
            {
                path: '/admin/usuarios',
                name: 'Dashboard - Usuários',
                component: () => import(/* webpackChunkName: "Usuário" */ '@/views/Admin/Profissionais/UsersList.vue')
            },
            {
                path: '/admin/usuarios/criar',
                name: 'Dashboard - Criar usuário',
                component: () => import(/* webpackChunkName: "Criar Usuário" */ '@/views/Admin/Profissionais/UsersCreate.vue')
            },
            {
                path: '/admin/usuarios/editar/:id',
                name: 'Dashboard - Editar usuário',
                component: () => import(/* webpackChunkName: "Editar Usuário" */ '@/views/Admin/Profissionais/UsersEdit.vue')
            }
        ]
    }
];

const userRoutes = [
    {
        path: '/user',
        component: UserLayout,
        meta: {
            requiresAuth: true,
            role: ['user']
        },
        children: [
            {
                path: '',
                name: 'Agenda',
                component: UserHomeView
            },
            {
                path: '/user/agendas',
                name: 'Reservas',
                component: () => import(/* webpackChunkName: "Ver agenda" */ '@/views/User/Agenda/AgendaListView.vue')
            },
            {
                path: '/user/salas',
                name: 'Salas',
                component: () => import(/* webpackChunkName: "Salas" */ '@/views/User/RoomsView.vue')
            }
            // {
            //     path: '/user/agendas/criar',
            //     name: 'Novo agendamento',
            //     component: () => import(/* webpackChunkName: "Novo agendamento" */ '@/views/User/Agenda/AgendaCreateView.vue')
            // },
            // {
            //     path: '/user/agendas/editar/:id',
            //     name: 'Editar agendamento',
            //     component: () => import(/* webpackChunkName: "Editar agendamento" */ '@/views/User/Agenda/AgendaEditView.vue')
            // },
        ]
    }
];

// Create router 
const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/views/LoginView.vue')
        },
        {
            path: '/recuperar-senha',
            name: 'Recuperação de senha',
            component: () => import('@/views/ResetPassword.vue')
        },
        ...adminRoutes,
        ...userRoutes,
        {
            path: '/:pathMatch(.*)*',
            name: 'Não encontrado',
            component: () => import('@/views/NotFoundView.vue')
        }
    ]
});

// Router guardian 
router.beforeEach((to, from, next) => {
    const isLoggedIn = store.state.isAuthenticated;
    const accessLevel = store.state.accessLevel;

    if (to.meta.requiresAuth) {
        if (!isLoggedIn) {
            return next('/login');
        }

        if (to.meta.role && !to.meta.role.includes(accessLevel)) {
            return next('/login');
        }
    }

    document.title = to.name || 'App';
    next();
});

export default router;
